import { useNavigate } from 'react-router-dom'
import posthog from 'posthog-js'

/**
 * «انتقال صندوق به همیان» — Android's `cnsAddDraftCashbox`, the card
 * `BoxListFragment` shows under «اولین صندوق خودتان را بسازید» whenever the
 * user has no fund. Its button does what `btnCreateDraftCashbox` does: the
 * box-type chooser in transfer mode.
 *
 * Shown on both zero-fund screens, the صندوق‌ها tab and home, because home is
 * where a member with no fund lands; `source` tells them apart in PostHog.
 */
export default function TransferFundCard({
    source,
}: {
    source: 'funds_empty' | 'home_empty'
}) {
    const navigate = useNavigate()
    return (
        <div className="bg-brand-soft rounded-card p-4 text-right">
            <p className="text-sm font-bold text-brand-deep">
                انتقال صندوق به همیان
            </p>
            <p className="mt-2 text-sm text-text-body leading-relaxed">
                اگر خارج از همیان مدیر صندوق قرض‌الحسنه‌ای دارای فعالیت و سابقه
                هستید، با انتقال اطلاعات صندوقتان، در همیان به فعالیت ادامه
                دهید.
            </p>
            <button
                type="button"
                onClick={() => {
                    posthog.capture('fund_create_origin_selected', {
                        is_transfer: true,
                        source,
                    })
                    navigate('/add-box?transfer=1')
                }}
                className="w-full mt-4 bg-green-1 text-white rounded-full py-2 text-sm font-bold cursor-pointer"
            >
                انتقال صندوق به همیان
            </button>
        </div>
    )
}
